



































import { Component, Vue, Watch, Prop } from 'vue-property-decorator'
import { Action, Getter, Mutation } from 'vuex-class'
import * as FileSaver from 'file-saver'
import _get from 'lodash/get'

import { Book, Seller, Offer } from '@/types'

@Component({
  components: {},
})
export default class NavBar extends Vue {
  @Prop({ required: false })
  public isVertical: boolean | undefined

  @Action('getOfferItemsCSV', { namespace: 'offerCarts' }) private getOfferItemsCSV: any
  @Getter('getLoggedIn', { namespace: 'auth' }) private loggedIn: boolean | undefined
  @Getter('getActiveOffer', { namespace: 'offerCarts' }) private activeOffer: Offer | undefined

  private requestExportOfferItems: boolean = false

  get visibleBack() {
    return this.loggedIn && this.title !== 'Home'
  }

  get visibleCSVExport() {
    return _get(this.$route, ['meta', 'title']) === 'Offer Cart' && this.activeOffer
  }

  get title() {
    return _get(this.$route, ['meta', 'title']) || ''
  }

  private mounted(): void {}

  private destroyed(): void {}

  private handleExportOfferItems() {
    this.requestExportOfferItems = true
    this.getOfferItemsCSV({
      offset: 0,
      order: [],
      offerId: this.activeOffer!.id,
    })
      .then(res => {
        const csvData = new Blob([res], { type: 'text/csv;charset=utf-8;' })
        FileSaver.saveAs(csvData, `offer-items.csv`)
      })
      .catch(err => {})
      .finally(() => {
        this.requestExportOfferItems = false
      })
  }

  private handleBackButton() {
    if (this.title !== 'Home') this.$router.go(-1)
  }

  private handleToggleMenu(): void {
    this.$emit('handleToggleMenu')
    return
  }

  private handleClickNavItem(routerName: string) {
    if (this.$route.name !== routerName) {
      this.$router.push({ name: routerName })
    }
  }
}
